module.exports = __webpack_public_path__ + "static/img/411.640.723.412b63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/411.640.723.jpg
// module id = 207
// module chunks = 1